export default function onBreakpointChange(breakpoint, cb, dir = 'up') {
  const width = dir === 'up' ? 'min-width' : 'max-width';
  const mediaQuery = window.matchMedia(`(${width}: ${breakpoint}px)`);

  if (mediaQuery.matches) {
    cb();
  }

  mediaQuery.addEventListener('change', mediaQueryEvent => {
    if (mediaQueryEvent.matches) {
      cb();
    }
  });
}
